/**
 * @module tree/swap
 */

import append from './append.js'
import mutations from './mutations.js'
import resolvable from '../utils/resolvable.js'
import manager from '../contracts/manager.js'

const options = {
  childList: true
}

/**
 * Moves any added nodes from a container to another one
 * @param {Element|DocumentFragment} from
 * @param {Element|DocumentFragment} to
 */
export default async (
  from,
  to
) => {
  const [promise, { resolve }] = resolvable()
  
  queueMicrotask(async () => {
    const nodes = []
    
    for await (const { addedNodes } of mutations(from, options)) {
      await manager.fragment(...addedNodes)
      append(to, ...addedNodes)
      nodes.push(...addedNodes)
    }
    
    resolve([...new Set(nodes)])
  })
  
  return promise
}
